import React from "react";
import PropTypes from "prop-types";
import { Table, Pagination, Divider } from "semantic-ui-react";
import { PageSizeSelect } from "./paging/page-size-select";
import QsrCommentaryDataTable from "../table/qsr-commentary-data-table";
import DataProvider from "./data-providers/data-provider";
import { Observable, Subject, merge } from "rxjs";
import ExportDataProvider from "./data-providers/export-data-provider";
import { BasicFilter } from "./filters/basic-filter";
import { NoFilter } from "./filters/no-filter";

export default class WithoutFilteringQsrCommentaryDatatable extends React.Component {
    constructor(props) {
        super(props);
        this.localRefreshTrigger = new Subject();
        this.onRefreshTrigger = this.generateRefreshTrigger();

        this.state = {
            totalCount: this.props.data ? this.props.data.length : 0,

            isLoading: false,
            pageSettings: {
                pageNo: this.props.startingPage || 1,
                pageSize: this.props.startingLimit || 10
            },
            filterSettings: {
                filter: "",
                fromDate: null,
                toDate: null
            }
        }
    }

    componentDidMount = () => {
      
        this.getRecentFilter();
    }


    componentDidUpdate() {

    }

    getRecentFilter() {

        if (this.props.storeName !== "" && this.props.clearStore === false) {
            this.setState(prevState => {
                return {
                    ...prevState,
                    filterSettings: {
                        filter: localStorage.getItem(this.props.storeName)
                    }
                };
            });
            this.requestRefresh()

        } else if (this.props.storeName !== "" && this.props.clearStore) {
            localStorage.removeItem(this.props.storeName)
            this.requestRefresh()

        }




    }

    generateRefreshTrigger() {
        const dependents = [this.localRefreshTrigger];
        if (this.props.refreshDataTrigger) {
            dependents.push(this.props.refreshDataTrigger);
        }
        return merge(...dependents);
    }

    get totalPages() {
        return Math.ceil(this.state.totalCount / this.state.pageSettings.pageSize);
    }

    onChangeLimit = (event, data) => {


        const pageSize = data.value;

        if (pageSize === 'All') {
            if (pageSize !== this.state.totalCount) {
                const pageSettings = { pageNo: this.state.pageSettings.pageNo, pageSize: this.state.totalCount };
                this.setState({ pageSettings }, this.requestRefresh);
            }
        }
        else if (pageSize !== this.state.pageSettings.pageSize) {
            const pageSettings = { pageNo: this.state.pageSettings.pageNo, pageSize: pageSize };
            this.setState({ pageSettings }, this.requestRefresh);
        }
    };

    onChangePage = (event, data) => {
        const activePage = data.activePage;
        if (activePage !== this.state.pageSettings.pageNo) {
            const pageSettings = { pageNo: activePage, pageSize: this.state.pageSettings.pageSize };
            this.setState({ pageSettings }, this.requestRefresh);
        }
    };

    onFilterChange = (filterSettings) => {


        if (this.props.storeName !== "") {
            localStorage.setItem(this.props.storeName, filterSettings.filter)
        }
        this.setState({
            pageSettings: {
                pageNo: 1,
                pageSize: this.state.pageSettings.pageSize
            }
        })

        this.setState({ filterSettings }, this.requestRefresh);
    };

    getDataProviderContext = () => {
        const localContext = {
            pageSettings: this.state.pageSettings,
            filterSettings: this.state.filterSettings
        };

        if (!this.props.additionalProviderContext) {
            return localContext;
        }

        return { ...localContext, ...this.props.additionalProviderContext() }
    };

    updateTotalCount = (data) => {
        this.setState({ totalCount: data.totalCount, isLoading: false });



        if (this.props.onTableRefreshed) {



            this.props.onTableRefreshed(data);



        }
    };

    requestRefresh = () => {
        this.setState({ isLoading: true });
        this.localRefreshTrigger.next();


    };

    render() {
        const Filter = this.props.filterComponent || BasicFilter;
        return (
            <div className="filterable-table">
                {Filter !== NoFilter &&
                    <React.Fragment>
                        {/*   <Filter
                        filter={this.state.filterSettings.filter}
                        totalCount={this.state.totalCount}
                        onSubmitFilter={this.onFilterChange}
                        disabled={this.state.isLoading}
                        fromDate={this.state.filterSettings.fromDate}
                        toDate={this.state.filterSettings.toDate}
                   /> */}
                        <Divider />
                    </React.Fragment>}
                <QsrCommentaryDataTable dataProvider={this.props.dataProvider} canExport={this.props.canExport}
                    name={this.props.name} defaultSort={this.props.defaultSort}
                    headerComponent={this.props.headerComponent} rowComponent={this.props.rowComponent}
                    onTableRefreshed={this.updateTotalCount} refreshDataTrigger={this.onRefreshTrigger}
                    additionalProviderContext={this.getDataProviderContext}
                    exportDataProvider={this.props.exportDataProvider}
                    contextData={this.props.contextData}>
                    <QsrCommentaryDataTable.Header>
                        <React.Fragment>
                            <PageSizeSelect
                                limit={this.state.pageSettings.pageSize}
                                onChangeLimit={this.onChangeLimit} />
                            Total count: {this.state.totalCount}.
                        </React.Fragment>
                    </QsrCommentaryDataTable.Header>
                    <QsrCommentaryDataTable.Footer>
                        <Table.Footer>
                            <Table.Row>
                                <Table.HeaderCell colSpan="12">
                                    <Pagination
                                        totalPages={this.totalPages}
                                        activePage={this.state.pageSettings.pageNo}
                                        onPageChange={this.onChangePage} />
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Footer>
                    </QsrCommentaryDataTable.Footer>
                </QsrCommentaryDataTable>
            </div>
        );
    }
};

WithoutFilteringQsrCommentaryDatatable.propTypes = {
    dataProvider: PropTypes.instanceOf(DataProvider).isRequired,
    headerComponent: PropTypes.elementType.isRequired,
    rowComponent: PropTypes.elementType.isRequired,
    refreshDataTrigger: PropTypes.instanceOf(Observable),
    exportDataProvider: PropTypes.instanceOf(ExportDataProvider),
    onTableRefreshed: PropTypes.func,
    defaultSort: PropTypes.string,
    additionalProviderContext: PropTypes.func,
    name: PropTypes.string,
    storeName: PropTypes.string,
    clearStore: PropTypes.bool,
    canExport: PropTypes.bool,
    startingPage: PropTypes.number,
    startingLimit: PropTypes.string,
    filterComponent: PropTypes.elementType,
    contextData: PropTypes.any
};
